import { Injectable, inject, signal } from '@angular/core';
import { StorageService } from './storage.service';

/** Le dernier jour où Willy a salué, « AAAA-MM-JJ ». */
export const WILLY_GREETED_ON_KEY = 'willy-greeted-on';

/**
 * Le plafond du salut de Willy dans la carotte : une fois par jour au plus,
 * à la première ouverture du jour ou à l'arrivée d'un nouveau message du
 * jour, selon ce qui vient en premier. L'écran demande `claimToday()` ; à vrai,
 * il passe `greet` à la carotte (`vw-app-menu-central`).
 *
 * Sans stockage (navigation privée, stockage plein), Willy ne salue pas :
 * mieux vaut aucun salut qu'un salut à chaque ouverture.
 *
 * L'accueil appelle `greetIfFirstToday()` ; la barre du bas lit `greeting()`
 * pour la carotte, et `done()` la remet au repos.
 */
@Injectable({ providedIn: 'root' })
export class WillyGreetingService {
  private readonly storage = inject(StorageService);
  /** Willy doit saluer dans la carotte. */
  readonly greeting = signal(false);

  /** Première ouverture du jour : Willy salue. */
  greetIfFirstToday(now: Date = new Date()): void {
    if (this.claimToday(now)) this.greeting.set(true);
  }

  /** La carotte a fini (ou n'a pas pu) saluer. */
  done(): void {
    this.greeting.set(false);
  }

  /** Vrai à la première demande du jour, et le note ; faux ensuite jusqu'au lendemain. */
  claimToday(now: Date = new Date()): boolean {
    const today = now.toLocaleDateString('en-CA');
    try {
      if (this.storage.getItem(WILLY_GREETED_ON_KEY) === today) return false;
      this.storage.setItem(WILLY_GREETED_ON_KEY, today);
      return true;
    } catch {
      return false;
    }
  }
}
